import Meter from "components/Meter";
import { number } from "prop-types";

import common from "./common.module.scss";

const WizardProgressBar = ({ value }) => {
  return (
    <Meter
      barClassName={common.bar}
      className={common.meter}
      high={0}
      id="wizard-progress-bar"
      max={100}
      progressClassName={common.progress}
      showLabel={false}
      size={8}
      value={value}
    />
  );
};

WizardProgressBar.propTypes = {
  value: number,
};

export default WizardProgressBar;
